module.exports = __webpack_public_path__ + "static/media/favicon.26c49b26.ico";